// Copyright (C) 2022 Cochise Ruhulessin
//
// All rights reserved. No warranty, explicit or implicit, provided. In
// no event shall the author(s) be liable for any claim or damages.
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
import { IonButton, IonCol, IonGrid, IonItem, IonItemDivider, IonItemGroup, IonLabel, IonList, IonRow, IonText } from "@ionic/react"
import { useLocales } from "react-localized"
import useSession from "./useSession"


interface ErrorPageContentProps {
  error?: boolean | string | null
}


const ErrorPageContent: React.FC<ErrorPageContentProps> = ({error}) => {
  const {gettext} = useLocales()
  const {setError} = useSession()
  return (
    <IonGrid className="panel">
      <IonRow>
        <IonCol sizeMd="8" sizeLg="6" sizeXl="4">
          <IonList lines="none">
            <IonItemGroup>
              <IonItemDivider>
                <IonLabel style={{marginTop: "0px"}}>
                  {gettext("Something went wrong")}
                </IonLabel>
              </IonItemDivider>
              <IonItem>
                <IonText>
                  <p>{gettext("Contact support if the problem persists.")}</p>
                </IonText>
              </IonItem>
            </IonItemGroup>
          </IonList>
          <IonButton
            className="text-start"
            fill="clear"
            onClick={() => setError(false)}
            style={{textAlign: "left"}}
          >
            {gettext("Close this message")}
          </IonButton>
        </IonCol>
      </IonRow>
    </IonGrid>
  )
}


export default ErrorPageContent